import { gql } from '@apollo/client';

/*
** ADD MEDIA APPROVAL **
*/

export const ADD_MEDIA_APPROVAL = gql`
  mutation addMediaApproval($input: MediaApprovalInput!) {
    addMediaApproval(input: $input) {
      mediaId
      message
    }
  }
`;


export type MediaApprovalInput = {
  maTitle: string;
  maDescription?: string;
  maType: string;
  maCategory: string;
  maTags: string[];
  maS3MediaKeyUrl: string;
  maS3ThumbnailKeyUrl: string;
  maDuration?: string;
};

export type AddMediaApprovalData = {
  addMediaApproval: {
    mediaId: string;
    message: string;
  };
};

/*
** EDIT MEDIA APPROVAL **
*/

export const EDIT_MEDIA_APPROVAL = gql`
  mutation editMediaApproval($input: MediaApprovalPatch!) {
    editMediaApproval(input: $input) {
      mediaId
      message
    }
  }
`;

export type MediaApprovalPatch = {
  maId?: string;
  maUploadStatus?: string;
  maTitle?: string;
  maDescription?: string;
  maCategory?: string;
  maTags?: string[];
  maDuration?: string;
};

export type EditMediaApprovalData = {
  editMediaApproval: {
    mediaId: string;
    message: string;
  };
};

/*
** DELETE MEDIA APPROVAL **
*/

export const DELETE_MEDIA_BY_MEDIA_ID = gql`
mutation deleteMediaByMediaId($maId: String!) {
  deleteMediaByMediaId(maId: $maId) {
    mediaId
    message
  }
}`;

export type DeleteMediaByMediaIdData = {
  deleteMediaByMediaId: {
    mediaId: string;
    message: string;
  };
};

export const EDIT_MEDIA = gql`mutation editMediaApproval($input: MediaApprovalPatch!) {
  editMediaApproval(input: $input) {
    mediaId
    message
  }
}`

export type EditMediaData = {
  editMediaApproval: {
    mediaId: string;
    message: string;
  };
};

export type LikeMediaResult = {
  isLiked: boolean;
  likeCount: number;
  mediaId: string;
};

export type LikeMediasData = {
  likeMedias: LikeMediaResult[];
};

export type UnlikeMediasData = {
  unlikeMedias: LikeMediaResult[];
};

export type LikeMediasVariables = {
  mediaIds: string[];
  playlistId?: string;
};

export const LIKE_MEDIAS = gql`
  mutation likeMedias($mediaIds: [String!]!, $playlistId: String) {
    likeMedias(mediaIds: $mediaIds, playlistId: $playlistId) {
      isLiked
      likeCount
      mediaId
    }
  }
`;

export const UNLIKE_MEDIAS = gql`
  mutation UnlikeMedias($mediaIds: [String!]!) {
    unlikeMedias(mediaIds: $mediaIds) {
      isLiked
      likeCount
      mediaId
    }
  }
`;

